import { Component, OnDestroy, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AbToastr } from 'app/abstract/services/toastr.abstract';
import { Subject, Subscription } from 'rxjs';
import { timeout, takeUntil } from 'rxjs/operators';
import { AbLogin } from "app/abstract/content-pages/login/login.abstract";
import { AbPostHog } from "app/abstract/services/posthog.abstract";
import { PostHogEventEnum } from "enums/posthog-event.enum";
@Component({
  selector: 'app-confirm-2-fa-page',
  templateUrl: './confirm-2FA-page.component.html',
  styleUrls: ['./confirm-2FA-page.component.scss', './../login/login-page.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class Confirm2FAPageComponent implements OnInit, OnDestroy {

  @Input() hashMfa: string;
  @Input() login: any;
  @Input() fatorSelecionado: string;
  @Input() identificadorFator: string;
  @Input() temMultiplosFatores: boolean = false;

  email: string;
  tempoRestante: number = 180;
  isReenviarCodigo: boolean = false;
  isCodigoInvalido: boolean = false;
  codigo2FA: string = "";
  private countdownInterval: any;
  private countdownStartTime: number = 0;
  private readonly COUNTDOWN_DURATION = 180;
  private sub$: Subscription[] = []
  private destroy$ = new Subject<void>();
  isValidating: boolean = false;
  isBlockLimitAttempt: boolean = false;
  private isValidated: boolean = false;
  attemptCount: number = 0;
  private readonly MAX_ATTEMPTS = 5;
  private readonly REQUEST_TIMEOUT = 30000;

  get isButtonDisabled(): boolean {
    return this.codigo2FA.length < 6 || this.isValidating || this.isBlockLimitAttempt || this.isCodigoInvalido;
  }

  constructor(
    private toastrService: AbToastr,
    private translateService: TranslateService,
    private loginService: AbLogin,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private posthog: AbPostHog,
  ) { }

  ngOnInit(): void {
    this.startCountdown();
  }

  reenviarCodigo2FA() {
    this.loginService.enviarTokenMfa(this.hashMfa, this.fatorSelecionado).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.tempoRestante = this.COUNTDOWN_DURATION;
        this.startCountdown();
      },
      () => {
        this.toastrService.warning(this.translateService.instant("Erro ao reenviar código de verificação"));
      }
    );
  }

  alterTypeFactor(){
    this.loginService.doLogin(this.login);
    this.activeModal.dismiss();
  }

  startCountdown() {
    this.isReenviarCodigo = false;
    this.isCodigoInvalido = false;
    this.countdownStartTime = Date.now();
    this.tempoRestante = this.COUNTDOWN_DURATION;

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    this.countdownInterval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - this.countdownStartTime) / 1000);
      this.tempoRestante = Math.max(0, this.COUNTDOWN_DURATION - elapsedSeconds);

      if (this.tempoRestante <= 0) {
        this.isReenviarCodigo = true;
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  autoValidate(code: string) {

    this.codigo2FA = code?.replace(/[^0-9]/g, '') || '';

    if (this.isCodigoInvalido) {
      this.isCodigoInvalido = false;
    }
  }

  validarAcessoCodigo() {

    if (!this.codigo2FA || !/^\d{6}$/.test(this.codigo2FA)) {
      this.toastrService.warning(this.translateService.instant("Código deve conter exatamente 6 dígitos"));
      return;
    }

    if (this.isButtonDisabled) {
      return;
    }

    this.attemptCount++;

    if (this.isValidated || this.attemptCount > this.MAX_ATTEMPTS) {
      this.isBlockLimitAttempt = true;
      this.toastrService.warning(this.translateService.instant("Muitas tentativas. Tente novamente mais tarde."));
      this.blockFurtherAttempts();
      return
    }

    this.isCodigoInvalido = false;

    this.isValidating = true;
    this.loginService.validarTokenMfa(this.hashMfa, this.codigo2FA)
      .pipe(
        timeout(this.REQUEST_TIMEOUT),
        takeUntil(this.destroy$)
      ).subscribe(
        (token) => {
          this.isValidating = false;
          this.isValidated = true;
          this.clearSensitiveData();
          this.posthog.capture(PostHogEventEnum.MFA_VALIDADO);
          this.loginService.loadUser(token, undefined, true);
        },
        (error) => {
          this.isValidating = false;
          this.isCodigoInvalido = true;
          const motivo = error?.name === 'TimeoutError' ? 'timeout' : 'mfa_invalido';
          this.posthog.capture(PostHogEventEnum.LOGIN_FALHOU, { motivo });

          if (this.attemptCount > this.MAX_ATTEMPTS) {
            this.toastrService.warning(this.translateService.instant("Muitas tentativas. Tente novamente mais tarde."));
            this.blockFurtherAttempts();
          }
        }
      );
  }

  dismissModal = () => {
    this.modalService.dismissAll();
  };

  clearSensitiveData(): void {
    this.codigo2FA = '';
  }

  blockFurtherAttempts(): void {
    this.isValidated = true;
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.sub$.forEach((sub) => sub.unsubscribe());
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.clearSensitiveData();
  }

}
